import { a as getAssetPath } from './index-16457198.js';
import { h as hasIntersectionSupport } from './intersectionSupport.utils-eabf003c.js';

/**
 * get stenciljs assets path based on name and size props
 * @param name
 * @param path
 */
function getUrl(name, path) {
  if (!name)
    return;
  const fileName = getFileName(name);
  return getAssetPath(path + "/" + fileName);
}
/**
 * get stripped filename to svg
 * @param name
 */
function getFileName(name) {
  if (!name)
    return;
  const fileName = name.replace(/(.)([A-Z])/g, "$1-$2").toLowerCase();
  return `${fileName}.svg`;
}
/**
 * lazy loading
 */
const observeIconElement = (lazy, el, callback) => {
  if (lazy && hasIntersectionSupport()) {
    const observer = new IntersectionObserver((data) => {
      if (data[0].isIntersecting) {
        observer.disconnect();
        callback();
      }
    }, { rootMargin: "50px" });
    observer.observe(el);
    return observer;
  }
  else {
    callback();
    return undefined;
  }
};

const iconContent = new Map();
const requests = new Map();
function getSvgContent(url) {
  // see if we already have a request for this url
  let request = requests.get(url);
  if (!request) {
    // we don't already have a request
    request = fetch(url).then((response) => {
      if (response.ok) {
        return response.text().then((svgContent) => {
          iconContent.set(url, svgContent);
          return svgContent;
        });
      }
      iconContent.set(url, "");
    });
    // cache for the same requests
    requests.set(url, request);
  }
  return request;
}

export { getSvgContent as a, getUrl as g, iconContent as i, observeIconElement as o };
